import { Skeleton } from '@brg/ui';
import styled from 'styled-components';
import { ProjectCardContainerNew } from '../projectCard/stylesNew';
import AspectRatio from '../util/AspectRatio';
import { LayoutConst } from 'core';
const SkeletonWrapper = styled(ProjectCardContainerNew)``;

export const SkeletonCard = () => (
    <SkeletonWrapper isLoading={true}>
        <Skeleton width={'100%'} height={'100%'} />
    </SkeletonWrapper>
)

export const SkeletonCardMap = () => (
  // @ts-ignore
  <AspectRatio ratio={LayoutConst.mapCard.l.w / LayoutConst.mapCard.l.h}>
    <Skeleton width={'100%'} height={'100%'} />
  </AspectRatio>
)import { Skeleton } from '@brg/ui';
import styled from 'styled-components';
import { ProjectCardContainerNew } from '../projectCard/stylesNew';
import AspectRatio from '../util/AspectRatio';
import { LayoutConst } from 'core';
const SkeletonWrapper = styled(ProjectCardContainerNew)``;

export const SkeletonCard = () => (
    <SkeletonWrapper isLoading={true}>
        <Skeleton width={'100%'} height={'100%'} />
    </SkeletonWrapper>
)

export const SkeletonCardMap = () => (
  // @ts-ignore
  <AspectRatio ratio={LayoutConst.mapCard.l.w / LayoutConst.mapCard.l.h}>
    <Skeleton width={'100%'} height={'100%'} />
  </AspectRatio>
)